var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[_c('h3',[_vm._v("加入我们")]),_c('div',{staticClass:"conent"},[_c('img',{attrs:{"src":_vm.img,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }